import axios from "axios";
import API from "../api";
import qs from "querystring";

export const AccommodationsModule = {
  state: {
    unitTypeList: [],
    units: [],
    unitPricingRules: {},
    availableUnits: [], // set available rooms by date here
    errored: false,
    error: "",
    isRequesting: true,
    isRequestingUnitTypes: false,
    isRequestingUnits: false
  },
  actions: {
    fetchAccommodations({
      commit
    }) {
      commit("getUnitTypeListRequest");
      commit("getUnitsRequest");
      axios
        .all([
          axios.get(`${API.BASE_URL}${API.UNIT}`, API.RequestHeaders()),
          axios.get(
            `${API.BASE_URL}${API.UNIT_TYPE_LIST}`,
            API.RequestHeaders()
          )
        ])
        .then(
          axios.spread((unitListResponse, unitTypeListResponse) => {
            if (
              unitTypeListResponse.status === 200 &&
              unitListResponse.status === 200
            ) {
              commit("getUnitTypeListSuccess", unitTypeListResponse.data);
              commit("getUnitsSuccess", unitListResponse.data);
            }
          })
        )
        .catch(error => {
          commit("getUnitsAndUnitTypesError", error.message);
        });
    },
    addUnitType({
      commit
    }, record) {
      return new Promise((resolve, reject) => {
        commit("addUnitTypeRequest");
        let submitData = Object.assign({}, record);
        submitData.show_in_db = submitData.show_in_db ? 1 : 0;

        axios
          .post(
            `${API.BASE_URL}${API.UNIT_TYPE}`,
            qs.stringify(submitData),
            API.FormRequestHeaders()
          )
          .then(response => {
            if (response.status === 201) {
              commit("addUnitTypeSuccess", response.data.original);
              resolve();
            }
          })
          .catch(error => {
            commit("addUnitTypeError", error.message);
            reject(error.message);
          });
      });
    },
    deleteUnitType({
      commit
    }, Id) {
      return new Promise((resolve, reject) => {
        commit("removeUnitTypeRequest");
        axios
          .delete(
            `${API.BASE_URL}${API.UNIT_TYPE}/${Id}`,
            API.RequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("removeUnitTypeSuccess", Id);
              resolve();
            }
          })
          .catch(error => {
            commit("removeUnitTypeError", error.message);
            reject(error.message);
          });
      });
    },
    updateUnitType({
      commit
    }, _record) {
      return new Promise((resolve, reject) => {
        commit("updateUnitTypeRequest");

        const submitData = {
          base_rate: _record.base_rate,
          unit_type_description: _record.unit_type_description,
          unit_type_name: _record.unit_type_name,
          show_in_db: _record.show_in_db ? 1 : 0
        };

        const recordId = _record.id;

        axios
          .put(
            `${API.BASE_URL}${API.UNIT_TYPE}/${recordId}`,
            qs.stringify(submitData),
            API.FormRequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("updateUnitTypeSuccess", response.data.original);
              resolve();
            } else {
              // reject()
            }
          })
          .catch(error => {
            commit("updateUnitTypeError", error.message);
            reject(error.message);
          });
      });
    },
    fetchAvailableUnitsByDate({commit}, dates) {
      return new Promise((resolve, reject) => {
        commit("getAvailableUnitsRequest");
        const { headers } = API.RequestHeaders();
        axios.get(`${API.BASE_URL}${API.UNIT_AVAILABILITY}`, {
          headers,
          params: {
            starts_at: dates.starts_at,
            ends_at: dates.ends_at
          }
        })
          .then(response => {
            if (response.status === 200) {
              commit("getAvailableUnitsSuccess", response.data);
              resolve();
            }
          })
          .catch(error => {
            commit("getAvailableUnitsError", error.message);
            reject();
          });
      });
    },
    addUnit({
      commit
    }, formData) {
      return new Promise((resolve, reject) => {
        commit("addUnitRequest");
        const submitData = {
          unit_type_id: formData.unit_type_id,
          unit_name: formData.unit_name,
          unit_rate: formData.unit_rate || undefined,
          unit_description: formData.unit_description,
          occ_adults: formData.occ_adults,
          occ_children: formData.occ_children,
          default_occupancy: formData.default_occupancy,
          show_in_db: formData.show_in_db ? 1 : 0
        };

        axios
          .post(
            `${API.BASE_URL}${API.UNIT}`,
            qs.stringify(submitData),
            API.FormRequestHeaders()
          )
          .then(response => {
            commit("addUnitSuccess", response.data.original);
            resolve();
          })
          .catch(error => {
            commit("addUnitError", error.message);
            reject(error.message);
          });
      });
    },
    updateUnit({
      commit
    }, formData) {
      return new Promise((resolve, reject) => {
        commit("updateUnitRequest");

        const submitData = {
          unit_name: formData.unit_name,
          unit_rate: formData.unit_rate,
          unit_description: formData.unit_description,
          unit_type_id: formData.unit_type_id,
          occ_adults: formData.occ_adults,
          occ_children: formData.occ_children,
          default_occupancy: formData.default_occupancy,
          show_in_db: formData.show_in_db ? 1 : 0
        };

        axios
          .put(
            `${API.BASE_URL}${API.UNIT}/${formData.id}`,
            qs.stringify(submitData),
            API.FormRequestHeaders()
          )
          .then(response => {
            if (response.status === 200) {
              commit("updateUnitSuccess", response.data.original);
              resolve();
            }
          })
          .catch(error => {
            commit("updateUnitError", error.message);
            reject(error.message);
          });
      });
    },
    removeUnit({
      commit
    }, unitId) {
      return new Promise((resolve, reject) => {
        commit("removeUnitRequest");
        axios
          .delete(`${API.BASE_URL}${API.UNIT}/${unitId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("removeUnitSuccess", unitId);
              resolve();
            }
          })
          .catch(error => {
            commit("removeUnitError", error.message);
            reject();
          });
      });
    },

    addUnitPricingRule({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${API.BASE_URL}/unitprices`, params, API.RequestHeaders())
          .then(res => {
            commit('addUnitPricingRuleSuccess', res.data);
            resolve();
          })
          .catch(err => {
            commit("unitPricingRuleRequestError", err.message);
            reject();
          });
      });
    },

    updateUnitPricingRule({ commit }, params) {
      let requestUri = `${ API.BASE_URL }/unitprices/${ params.id }`;

      return new Promise((resolve, reject) => {
        axios.put(requestUri, params, API.RequestHeaders())
          .then(res => {
            commit('updateUnitPricingRuleSuccess', res.data);
            resolve();
          })
          .catch(err => {
            commit('unitPricingRuleRequestError', err.message);
            reject();
          })
      });
    },

    deleteUnitPricingRule({ commit }, params) {
      let requestUri = `${ API.BASE_URL }/unitprices/${ params.id }`;

      return new Promise((resolve, reject) => {
        axios.delete(requestUri, API.RequestHeaders())
          .then(res => {
            commit('deleteUnitPricingRuleSuccess', params);
            resolve();
          })
          .catch(err => {
            commit('unitPricingRuleRequestError', err.message);
            reject();
          });
      });
    },
  },
  mutations: {
    getUnitTypeListRequest(state) {
      state.isRequestingUnitTypes = true;
    },

    getUnitTypeListSuccess(state, payload) {
      state.isRequestingUnitTypes = false;
      state.unitTypeList = payload;
    },

    getUnitsRequest(state) {
      state.isRequestingUnits = true;
    },

    getUnitsSuccess(state, payload) {
      state.isRequestingUnits = false;
      state.units = payload;

      state.units.map(unit => {
        state.unitPricingRules[unit.id] = unit.unit_prices
          .sort((a, b) => a.priority - b.priority);
      })
    },

    getAvailableUnitsRequest(state) {
      state.isRequesting = true;
    },

    getAvailableUnitsSuccess(state, payload) {
      state.isRequesting = false;
      state.availableUnits = payload;
    },

    getAvailableUnitsError(state) {
      state.errored = true;
      state.error = payload;
    },

    // using axios.all we resolve both requests but if one fails, both will
    // so we use one error mutation.
    getUnitsAndUnitTypesError(state, payload) {
      state.isRequestingUnits = false;
      state.isRequestingUnitTypes = false;
      state.errored = true;
      state.error = payload;
    },

    updateUnitTypeRequest(state) {
      state.isRequesting = true;
    },

    updateUnitTypeSuccess(state, payload) {
      state.isRequesting = false;
      const updatedUnitType = state.unitTypeList.find(
        unitType => unitType.id === payload.id
      );
      Object.assign(updatedUnitType, payload);
    },
    updateUnitTypeError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    removeUnitTypeRequest(state) {
      state.isRequesting = true;
    },

    removeUnitTypeSuccess(state, payload) {
      state.isRequesting = false;
      const deletedUnitType = state.unitTypeList.find(
        unitType => unitType.id === payload
      );
      const currentIndex = state.unitTypeList.indexOf(deletedUnitType);
      state.unitTypeList.splice(currentIndex, 1);
    },

    removeUnitTypeError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    addUnitTypeRequest(state) {
      state.isRequesting = true;
    },

    addUnitTypeSuccess(state, payload) {
      // This is necessary to make the units reactive... Otherwise, the first unit of a type won't show
      if (!("unit" in payload)) {
        payload["unit"] = [];
      }
      state.unitTypeList.push(payload);
      state.isRequesting = false;
    },

    addUnitTypeError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    addUnitRequest(state) {
      state.isRequesting = true;
    },

    addUnitSuccess(state, payload) {
      state.isRequesting = false;
      // find the parent object of the added unit
      const parentObject = state.unitTypeList.find(
        unitType => unitType.id === payload.unit_type_id
      );
      // find the index of the parent object
      const parentObjectIndex = state.unitTypeList.findIndex(
        unit => unit.id === parentObject.id
      );
      if ("unit" in state.unitTypeList[parentObjectIndex]) {
        state.unitTypeList[parentObjectIndex].unit.push(payload);
      } else {
        state.unitTypeList[parentObjectIndex].unit = [payload];
      }

      state.units.push(payload);
    },

    addUnitError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    updateUnitRequest(state) {
      state.isRequesting = true;
    },

    updateUnitSuccess(state, payload) {
      state.isRequesting = false;
      let updateRecord = null;
      let updatedUnit = state.unitTypeList.find(unitType => {
        let result = unitType.unit.find(unit => {
          return unit.id === payload.id;
        });
        updateRecord = result;
        return result;
      });
      Object.assign(updateRecord, payload);
    },

    updateUnitError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    removeUnitRequest(state) {
      state.isRequesting = true;
    },

    removeUnitSuccess(state, payload) {
      state.isRequesting = false;
      let unitType = state.unitTypeList.find(unitType => unitType.unit.some(_unit => _unit.id === payload));
      let unitIndex = unitType.unit.findIndex(_unit => _unit.id === payload);
      unitType.unit.splice(unitIndex, 1);
    },

    removeUnitError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },

    addUnitPricingRuleSuccess(state, payload) {
      payload.map(rule => {
        let unit_id = rule.unit_id;

        state.unitPricingRules[unit_id] = state.unitPricingRules[unit_id]
          ? state.unitPricingRules[unit_id]
          : [];

        state.unitPricingRules[unit_id].push(rule);
        state.unitPricingRules[unit_id] = state.unitPricingRules[unit_id]
          .sort((a, b) => a.priority - b.priority);
      })
    },

    updateUnitPricingRuleSuccess(state, payload) {
      let unit_id = payload.unit_id;
      let ruleIndex = state.unitPricingRules[unit_id]
        .findIndex(rule => rule.id === payload.id);

      if (ruleIndex > -1) {
        state.unitPricingRules[unit_id][ruleIndex] = payload;
        state.unitPricingRules[unit_id] = state.unitPricingRules[unit_id]
          .sort((a, b) => a.priority - b.priority);
      }
    },

    deleteUnitPricingRuleSuccess(state, payload) {
      let unit_id = payload.unit_id;
      let ruleIndex = state.unitPricingRules[unit_id]
        .findIndex(rule => rule.id === payload.id);

      if (ruleIndex > -1) {
        state.unitPricingRules[unit_id].splice(ruleIndex, 1);
      }
    },

    unitPricingRuleRequestError(state, payload) {
      state.errored = true;
      state.error = payload;
    },
  },
  getters: {
    getUnitById: (state) => (id) => {
      return state.units.find(unit => unit.id === id);
    },

    getUnitTypesList(state) {
      return state.unitTypeList;
    },

    getUnits(state) {
      return state.units;
    },

    getAvailableUnitsByDate(state) {
      return state.availableUnits;
    },

    getUnitPricingRules(state) {
      return state.unitPricingRules;
    }
  }
};
